import React from 'react';

import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { insertAll } from 'ramda';
import Money from '../../../common/money';
import { activeShopPaymentDepositsEnabled } from '../../../auth/selectors';

const withState = compose(
  connect(
    state => ({
      paymentDepositEnabled: activeShopPaymentDepositsEnabled(state),
    }),
  ),
);

export default compose(
  withState,
  withProps(({ paymentDepositEnabled, columns }) => {
    if (!paymentDepositEnabled) {
      return {};
    }

    return {
      columns: insertAll(10, [
        {
          Header: 'Booking Deposits',
          accessor: 'securedDepositsAmount',
          id: 'securedDepositsAmount',
          Cell: props => <Money cents={props.value} />,
        },
        {
          Header: 'Booking Deposits - Count',
          id: 'securedDepositsCount',
          accessor: ({ securedDepositsCount }) => securedDepositsCount || 0,
        },
      ], columns),
    };
  }),
);
